import { STORAGE_KEY } from 'constants/browserStorageKeys';

export const setSessionStorage = (key: STORAGE_KEY, value: any) => {
  return sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSessionStorage = (key: STORAGE_KEY) => {
  try {
    return JSON.parse(sessionStorage.getItem(key));
  } catch (e) {
    return null;
  }
};

export const removeSessionStorage = (key: STORAGE_KEY) => {
  sessionStorage.removeItem(key);
};
